/**
 * @license
 * Copyright 2020 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @internal
 */
export const PUPPETEER_REVISIONS = Object.freeze({
    chrome: '135.0.7049.114',
    'chrome-headless-shell': '135.0.7049.114',
    firefox: 'stable_137.0.2',
});
//# sourceMappingURL=revisions.js.map